<template>
    <app-content>
        <form action="#">
            <div class="inner">
                <p class="buttons">
                    <app-button-delete @click="deleteItem" v-if="!newItem"/>
                </p>
                <app-content-title v-if="!newItem"
                                   :title="item.name"/>
                <app-content-title v-if="newItem" :title="translations.newVideo"/>
            </div>
            <app-tabs
                :colsTabs="columnTabs"
                :shouldLoadFirstTab="newItem"
                :loadTab="params.tab"
                @appTabChanged="onAppTabChanged"
            >
            <div :title="translations.information">
                <app-settings @submit="onFormSubmit" :disabled="pending">
                    <app-settings-content>
                        <app-settings-desc :title="translations.basicInfo">
                            <p>
                                <translate>Založeno</translate>
                                :<br/>
                                <span v-html="formatDateAdvanced(item._created)"/>
                            </p>

                            <p>
                                <translate>Stav</translate>
                                :<br/>
                                <span v-html="item._state"/>
                            </p>

                            <p v-if="item._duration">
                                <translate>Délka</translate>
                                :<br/>
                                <span v-html="duration"/>
                            </p>
                        </app-settings-desc>

                        <app-settings-options>
                            <app-settings-col class="field_left">
                                <app-input
                                    :label="translations.name"
                                    required
                                    :error="errors.items.find(el => el.field === 'name')"
                                    v-model="formItem.name"
                                    name="name"
                                />
                            </app-settings-col>

                            <app-settings-col class="field_right">
                                <app-input
                                    :label="translations.showName"
                                    required
                                    :error="errors.items.find(el => el.field === 'idShow')"
                                    v-model="formItem.idShow"
                                    name="idShow"
                                    type="number"
                                    @input="idShowChanged"
                                />
                            </app-settings-col>

                            <app-settings-col class="field_left">
                                <app-settings-select
                                    required
                                    :error="errors.items.find(el => el.field === 'idProvider')"
                                    :label="translations.provider"
                                >
                                    <app-select
                                        :disabled="!newItem"
                                        selectId="provider"
                                        :options="providerOptions"
                                        v-model="formItem.idProvider"
                                        @change="selectProvider"
                                        name="idProvider"
                                    />
                                </app-settings-select>
                            </app-settings-col>
                            <app-settings-col class="field_right">
                                <app-input :label="translations.selectedShowName" :value="selectedShowTitle" disabled />
                            </app-settings-col>

                            <app-settings-col class="field_left">
                                <app-input
                                    :label="translations.importId"
                                    :error="errors.items.find(el => el.field === 'importId')"
                                    v-model="formItem.importId"
                                    name="importId"
                                />

                                <app-input
                                    :label="translations.episodeName"
                                    :error="errors.items.find(el => el.field === 'episodeName')"
                                    v-model="formItem.episodeName"
                                    name="episodeName"
                                    type="text"
                                />
                            </app-settings-col>

                            <app-settings-col class="field_right">
                                <app-datepicker
                                    :label="translations.providedFrom"
                                    :error="errors.items.find(el => el.field === 'providedFrom')"
                                    v-model="formItem.providedFrom"
                                    name="providedFrom"
                                />

                                <app-datepicker
                                    :label="translations.providedTo"
                                    :error="errors.items.find(el => el.field === 'providedTo')"
                                    v-model="formItem.providedTo"
                                    name="providedTo"
                                />
                            </app-settings-col>

                            <app-settings-col class="field_left">

                                <app-input
                                    :label="translations.seasonNumber"
                                    :error="errors.items.find(el => el.field === 'seasonNumber')"
                                    v-model="formItem.seasonNumber"
                                    name="seasonNumber"
                                    type="number"
                                />
                                <app-input
                                    :label="translations.episodeNumber"
                                    :error="errors.items.find(el => el.field === 'episodeNumber')"
                                    v-model="formItem.episodeNumber"
                                    name="episodeNumber"
                                    type="number"
                                />

                                <app-settings-control class="checkbox">
                                    <app-checkbox
                                        name="active"
                                        :title="translations.active"
                                        :error="!!errors.first('active')"
                                        v-model="formItem.active"
                                        @change="changeActive"
                                    />
                                </app-settings-control>
                                <app-settings-control class="checkbox">
                                    <app-checkbox
                                        name="accessibility"
                                        :title="translations.accessibility"
                                        :error="!!errors.first('accessibility')"
                                        v-model="formItem.accessibility"
                                        @change="changeAccessibility"
                                    />
                                </app-settings-control>
                            </app-settings-col>

                            <app-settings-col class="field_right">
                                <app-image-input
                                    name="imagePoster"
                                    pClass="field field_poster"
                                    :labelTitle="translations.poster"
                                    labelClass="poster add_profile_image"
                                    :text="translations.uploadPoster"
                                    spanClass="sizes"
                                    ref="imagePoster"
                                    :image="imagePoster"
                                    :imageLink="posterLink"
                                    :disabled="pending"
                                    :error="!!errors.first('imagePoster')"
                                    @fileChanged="onPosterChanged"
                                />
                                <app-image-input
                                    name="imageLandscape"
                                    pClass="field field_poster"
                                    :labelTitle="translations.icon"
                                    labelClass="photo add_profile_image"
                                    :text="translations.uploadLandscape"
                                    spanClass="sizes"
                                    ref="imageLandscape"
                                    :image="imageLandscape"
                                    :imageLink="landscapeLink"
                                    :disabled="pending"
                                    :error="!!errors.first('imageLandscape')"
                                    @fileChanged="onLandscapeChanged"
                                />
                            </app-settings-col>

                        </app-settings-options>
                    </app-settings-content>

                    <app-settings-buttons :navLinkTitle="translations.list" :nav-link-to="{ name: 'vodVideos' }">
                        <app-content-save-button :disabled="pending" @click="disallowBack"/>
                    </app-settings-buttons>
                </app-settings>
            </div>
            <div :title="translations.packages + ' (' + (item && item._packageIds ? item._packageIds.length : 0) + ')'"
                 :data-disabled-title="translations.packagesSaveFirst"
                 :data-disabled="!item || !item._id"
            >
                <Packages key="packages" :packages="packages" :assignedPackages="item._packageIds" @packagesChanged="onPackagesChanged" />
            </div>
            <div :title="translations.videoSources + ' (' + (item && item.videoContent ? item.videoContent.length : 0) + ')'"
                 :data-disabled-title="translations.videSourcesSaveFirst"
                 :data-disabled="!item || !item._id"
            >
                <Content key="videoContent" :item="formItem" type="videoContent" :label="translations.videoSources" />
            </div>
            <div :title="translations.audioSources + ' (' + (item && item.audioContent ? item.audioContent.length : 0) + ')'"
                 :data-disabled-title="translations.audioSourcesSaveFirst"
                 :data-disabled="!item || !item._id"
            >
                <Content key="audioContent" :item="formItem" type="audioContent" :label="translations.audioSources" />
            </div>
            <div :title="translations.subtitleSources + ' (' + (item && item.subtitleContent ? item.subtitleContent.length : 0) + ')'"
                 :data-disabled-title="translations.subtitleSourcesSaveFirst"
                 :data-disabled="!item || !item._id"
            >
                <Content key="subtitleContent" :item="formItem" type="subtitleContent" :label="translations.subtitleSources" />
            </div>
            <div :title="translations.trailerSources + ' (' + (item && item.trailerContent ? item.trailerContent.length : 0) + ')'"
                 :data-disabled-title="translations.trailerSourcesSaveFirst"
                 :data-disabled="!item || !item._id"
            >
                <Content key="trailerContent" :item="formItem" type="trailerContent" :label="translations.trailerSources" />
            </div>
            <div :title="translations.prices + ' (' + (item && item.prices ? item.prices.length : 0) + ')'"
                 :data-disabled-title="translations.pricesSaveFirst"
                 :data-disabled="!item || !item._id"
            >
                <Prices key="pricesList" :item="item" @pricesChanged="pricesChanged" />
            </div>
            <div :title="translations.metadata"
                 :data-disabled-title="translations.metadataNotSupplied"
                 :data-disabled="!item || !item._metadata"
            >
                <pre style="padding-left: 3em; padding-top: 25px;">
                    <JsonTree :json="item._metadata" />
                </pre>
            </div>
            </app-tabs>
        </form>
    </app-content>
</template>

<script>
import getItemDetailMixin from 'mixins/getItemDetailMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import {getCommonFormSubmit, setLoadingMessage} from 'utils/form'
import {mapActions, mapState} from "vuex";
import Content from "./Content";
import Prices from "@/views/Vod/Prices.vue";
import axios from "axios";
import {VUE_APP_BASE_API_URL} from "@/constants/fileConstants";
import Packages from "@/views/Vod/Video/Packages.vue";
import JsonTree from "@/views/Vod/Video/JsonTree.vue";

const itemDetailMixin = getItemDetailMixin({
  apiMethodsSuffix: 'Video',
  parentRouteName: 'vodVideos',
  storeModuleName: 'videos',
  storeItemName: 'video'
})

export default {
  name: 'video-item',
  components: {JsonTree, Packages, Prices, Content},
  mixins: [formatDateMixin, itemDetailMixin, appTitleMixin()],
  data() {
    return {
      active: false,
      accessibility: true,
      idProvider: null,
      show: null,
      itemJustSelected: false,
      columnTabs: [0, 1, 2, 3, 4, 5, 6, 7],
      imagePoster: null,
      imageLandscape: null,
      imagesUploading: false,
      posterLink: '',
      landscapeLink: '',
      posterChanged: false,
      landscapeChanged: false,
    }
  },
    mounted() {
        this.getProvidersByName();
        this.idShowChanged();
    },
    methods: {
    ...mapActions([
        'getProviders',
        'getPackages',
        'getShow',
        'updateVideoPrices',
        'updateVideoPackages'
    ]),
    async onFormSubmit(e) {
      this.errors.clear()

      this.formErrors = await this.runValidation()
      if (this.formErrors.items.length > 0) {
        this.appShowErrors(this.formErrors.items.map(v => v.msg))
        return
      }

      const commonFormSubmit = getCommonFormSubmit('Video')
      const response = await commonFormSubmit(this, e).catch(err => err.response)

      this.handleResponseIfError(response)
      if (this.posterChanged || this.landscapeChanged) {
          const { elements } = e.target;
          const imageApiUrl = VUE_APP_BASE_API_URL + 'videos/' + this.formItem._id + '/updateImage/';

          try {
              if (this.posterChanged) {
                  const formData = new FormData();
                  const filePoster = elements.namedItem('imagePoster').files[0];

                  if (filePoster) {
                      formData.set('fileExists', true);
                      formData.append('file', filePoster);
                  } else {
                      formData.set('fileExists', false);
                  }

                  formData.append('type', 'IMAGE_TYPE_PORTRAIT');
                  const uploadResult = await axios.post(imageApiUrl, formData);
              }

              if (this.landscapeChanged) {
                  const formData = new FormData();
                  const fileLandscape = elements.namedItem('imageLandscape').files[0];

                  if (fileLandscape) {
                      formData.set('fileExists', true);
                      formData.append('file', fileLandscape);
                  } else {
                      formData.set('fileExists', false);
                  }

                  formData.append('type', 'IMAGE_TYPE_LANDSCAPE');
                  const uploadResult = await axios.post(imageApiUrl, formData)
              }
          } finally {
              this.setImagesUploading(false);
              this.resetImagesChanged();
          }
      }

      if (!this.backAllowed && response.status === 201) {
        this.goToDetail(response.data.data._id)
      }
    },
    async runValidation() {
      await this.errors.clear()
      await this.$validator.validateAll()
      return this.errors
    },
    getProvidersByName() {
      this.getProviders({
        params: {
          order: 'name'
        }
      }).then(() => {
          if (this.formItem.idProvider) {
              this.getPackagesByIdProvider(this.formItem.idProvider);
          }
      });
    },
    getPackagesByIdProvider(idProvider) {
        this.getPackages({
            params: {
                idProvider: idProvider,
                order: 'name',
            }
        }).then((response) => {
            if (response.data.data.length > 0) {
                this.formItem.idPackage = this.idPackage = response.data.data[0]._id;
            } else {
                this.idPackage = null;
                this.formItem.idPackage = null;
            }
        });
    },
    selectProvider() {
      this.idProvider = this.formItem.idProvider;
    },
    idShowChanged() {
        this.show = null;

        if (this.formItem.idShow) {
            this.getShow({
                params: {
                    id: this.formItem.idShow
                }
            }).then((response) => {
                this.show = response.data.data;
            }).catch(() => {
                this.show = {
                    name: 'Pořad nenalezen.'
                }
            });
        }
    },
    pricesChanged(payload) {
        this.updateVideoPrices(payload);
    },
    changeActive(value) {
         this.active = value;
    },
    changeAccessibility(value) {
        this.accessibility = value;
    },
    setImagesUploading(uploading) {
      this.imagesUploading = uploading
      setLoadingMessage(this, uploading ? 'Nahrávání obrázků...' : null)
    },
    resetImagesChanged() {
      this.posterChanged = false
      this.landscapeChanged = false
    },
    onPosterChanged() {
      this.posterChanged = true
      this.posterLink = ''
    },
    onLandscapeChanged() {
      this.landscapeChanged = true
      this.landscapeLink = ''
    },
    setImageLinks() {
        if (this.item._imageLandscape) {
            this.landscapeLink = this.item._imageLandscape.imageLink;
        }

        if (this.item._imagePoster) {
            this.posterLink = this.item._imagePoster.imageLink;
        }
    },
    onPackagesChanged(packageIds) {
        this.updateVideoPackages({
            params: {
                id: this.item._id,
            },
            data: {
                packageIds: packageIds,
            }
        });
    }
  },
  computed: {
    ...mapState({
      providerOptions: (state, vm) => {
          return [
              ...state.providers.providers.map(({ _id, name }) => ({
                  value: _id,
                  name,
              }))
          ]
      },
      packages: (state, vm) => {
        return [...state.packages.packages]
      }
    }),
    duration() {
        const duration = this.item._duration;
        const hours = ~~(duration / 3600);
        const minutes = ~~((duration - hours * 3600) / 60);
        const seconds = duration % 60;

        const parts = [];
        if (hours > 0) {
            parts.push(hours + "h");
        }

        if (minutes > 0) {
            parts.push(minutes + "m");
        }

        if (seconds > 0) {
            parts.push(seconds + "s");
        }

        return parts.join(" ");
    },
    translations() {
      return {
        active: this.$gettext('Aktivní'),
        accessibility: this.$gettext('Přístupnost'),
        newVideo: this.$gettext('Nové video'),
        provider: this.$gettext('Provider'),
        name: this.$gettext('Název'),
        basicInfo: this.$gettext('Základní údaje'),
        list: this.$gettext('Seznam'),
        information: this.$gettext('Informace'),
        package: this.$gettext('Balíček'),
        importId: this.$gettext('Importní ID'),
        providedFrom: this.$gettext('Poskytováno od'),
        providedTo: this.$gettext('Poskytováno do'),
        showName: this.$gettext('ID pořadu'),
        selectedShowName: this.$gettext('Vybraný pořad dle ID'),
        packages: this.$gettext('Balíčky'),
        packagesSaveFirst: this.$gettext('Balíčky'),
        videoSources: this.$gettext('Zdroje videa'),
        videSourcesSaveFirst: this.$gettext('Zdroje videa'),
        audioSources: this.$gettext('Zdroje audia'),
        audioSourcesSaveFirst: this.$gettext('Zdroje audia'),
        trailerSources: this.$gettext('Zdroje trailerů'),
        trailerSourcesSaveFirst: this.$gettext('Zdroje trailerů'),
        subtitleSources: this.$gettext('Zdroje titulků'),
        subtitleSourcesSaveFirst: this.$gettext('Zdroje titulků'),
        metadata: this.$gettext('Metadata'),
        metadataNotSupplied: this.$gettext('Metadata (nejsou k dispozici)'),
        prices: this.$gettext('Ceny'),
        pricesSaveFirst: this.$gettext('Ceny'),
        uploadLandscape: this.$gettext('Landscape'),
        uploadPoster: this.$gettext('Poster'),
        seasonNumber: this.$gettext("Číslo série"),
        episodeNumber: this.$gettext("Číslo epizody"),
        episodeName: this.$gettext("Název epizody"),
      }
    },
    currentTitle() {
      return [
        { name: this.$gettext('Videa'), link: { name: 'vodVideos' } },
          this.item.name || this.translations.newVideo
      ]
    },
    selectedShowTitle() {
        return this.show ? this.show.name + " (#" + this.show._id + "; " + this.show.originalName + ")" : null;
    }
  },
  watch: {
    'formItem.idProvider'(newVal, oldVal) {
        if (newVal !== oldVal && newVal) {
            this.getProvidersByName();
        }
    },
    idProvider(newId, oldId) {
        this.getPackagesByIdProvider(newId);
    },
    item(newItem, oldItem) {
        if (!oldItem._id && newItem._id) {
            this.idShowChanged();
        }

        this.setImageLinks();
    }
  }
}
</script>
